import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { FIXED_INDENTS } from 'vars/index'
import type { CardAnimations } from '../Card.h'

import { TextAligning, TextBox, TextBoxTypes } from 'atoms/TextBox'
import { Colors } from 'atoms/TextBox/TextBox.h'
import { COLOR, LAYOUT } from 'vars/index'
import { CardContentContainerSC } from '../base-card'
import { Card } from '../Card'
import { CARDS_ASPECT_RATIO, CardCorners, CardsGradient } from '../Card.h'

export interface ICategoryCard {
  title?: string
  width?: string
  aspectRatio?: (typeof CARDS_ASPECT_RATIO)[keyof typeof CARDS_ASPECT_RATIO]
  children?: JSX.Element
  childrenTransition?: CardAnimations
  transitionName?: CardAnimations
  contentPaddings?: FIXED_INDENTS[] | LAYOUT[]
  gradient?: (typeof CardsGradient)[keyof typeof CardsGradient]
  corners?: CardCorners
  backgroundColor?: COLOR
  backgroundColorHovered?: COLOR
  font?: ITextBoxProps['font']
  textAlignment?: ITextBoxProps['alignment']
  textColor?: ITextBoxProps['color']
  textMaxLines?: ITextBoxProps['maxLines']
}

export const CategoryCard = ({
  title = '',
  width = '100%',
  aspectRatio = CARDS_ASPECT_RATIO.HORIZONTAL_DEFAULT,
  children,
  transitionName,
  gradient = CardsGradient.CategoryCard,
  corners = CardCorners.CORNERS_0,
  backgroundColor = COLOR.ACCENT_PRIMARY_GRADIENT,
  backgroundColorHovered = COLOR.ACCENT_PRIMARY_HOVERED_OVERLAY,
  font = TextBoxTypes.Headline3,
  textAlignment = TextAligning.Center,
  textColor = Colors.TEXT_ICON_PRIMARY,
  textMaxLines = 2,
  contentPaddings = [LAYOUT.VerticalCardsCategoryPaddings],
}: ICategoryCard): JSX.Element => {
  return (
    <Card
      posterEnabled={false}
      aspectRatio={aspectRatio}
      width={width}
      transitionName={transitionName}
      gradient={gradient}
      corners={corners}
      backgroundColor={backgroundColor}
      backgroundColorHovered={backgroundColorHovered}
    >
      <CardContentContainerSC paddings={contentPaddings}>
        {children ? (
          children
        ) : (
          <TextBox
            font={font}
            title={title}
            alignment={textAlignment}
            color={textColor}
            maxLines={textMaxLines}
          />
        )}
      </CardContentContainerSC>
    </Card>
  )
}
